<div class="tab-headers">
  <ng-content></ng-content>
</div>

<div class="tab-content">
  @if (isRouterMode()) {
    <ng-content select=".tab-outlet"></ng-content>
  } @else {
    @if (activeTab && activeTab.content()) {
      <ng-container [ngTemplateOutlet]="activeTab.content()!"></ng-container>
    }
  }
</div>
